import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

/**
 * 截屏分享
 *
 * @param {IBridgeOptions} { success, fail, complete }
 */
function shareSocialScreenShotSync({ success, fail, complete }: IBridgeOptions) {
  const params = formatParams({
    funType: 'share',
    funName: 'shareScreenShot'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('shareSocialScreenShotSync error: ', error)
  }
}

/**
 * 截屏分享
 * 一个异步接口，支持 Promise 化使用
 * @returns
 */
function shareSocialScreenShot() {
  const params = formatParams({
    funType: 'share',
    funName: 'shareScreenShot'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }
  return nativeJSBridge(opts)
}

export { shareSocialScreenShot, shareSocialScreenShotSync }
